import { getFirebaseAuth } from "@/config/firebase/firebaseClient";

import type {
  ActiveRoleType,
  UserRoleType,
  UserWorkspaceCapabilities,
  WorkspaceType,
} from "@/interFace/general";

export async function isUserVerified(id: string, token?: string): Promise<{ 
      isVerified: boolean; 
  isTester?: boolean;
      countryCode?: string; 
      countryName?: string, 
      yearOfBirth?: number | null,
      nickname?: string;
      isRegistered?: boolean;
      accountTypeId?: number;
        profiles?: string[];
      roleId?: number;
  roles?: UserRoleType[];
  activeRole?: ActiveRoleType;
  workspaces?: WorkspaceType[];
  defaultWorkspace?: WorkspaceType | null;
  capabilities?: UserWorkspaceCapabilities;
}> {
  try {
    let authToken = token;

    if (!authToken) {
      const auth = await getFirebaseAuth();
      const user = auth.currentUser;
      if (user) {
        authToken = await user.getIdToken();
      }
    }

    const response = await fetch("/api/member/isVerified", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : {}),
      },
      body: JSON.stringify({ id: id }),
    });

    if (!response.ok) return { isVerified: false };
    const responseData = await response.json();
    return {
      ...responseData,
      isVerified: (responseData?.isVerified ?? responseData?.IsVerified) === true,
      isTester: responseData?.isTester ?? responseData?.IsTester ?? false,
      countryCode: responseData?.countryCode ?? responseData?.CountryCode,
      countryName: responseData?.countryName ?? responseData?.CountryName,
      yearOfBirth: responseData?.yearOfBirth ?? responseData?.YearOfBirth,
      nickname: responseData?.nickname ?? responseData?.Nickname,
      isRegistered: responseData?.isRegistered ?? responseData?.IsRegistered,
      accountTypeId: responseData?.accountTypeId ?? responseData?.AccountTypeId,
      profiles: responseData?.profiles ?? responseData?.Profiles ?? [],
      roleId: responseData?.roleId ?? responseData?.RoleId,
      roles: responseData?.roles ?? responseData?.Roles,
      activeRole: responseData?.activeRole ?? responseData?.ActiveRole,
      workspaces: responseData?.workspaces ?? responseData?.Workspaces,
      defaultWorkspace:
        responseData?.defaultWorkspace ?? responseData?.DefaultWorkspace,
      capabilities: responseData?.capabilities ?? responseData?.Capabilities,
    };
  } catch (error) {
    console.error("Error checking verification status:", error);
    return { isVerified: false };
  }
}
